module.exports = __webpack_public_path__ + "img/person_4_index.32f474d1.png";